module.exports = __webpack_public_path__ + "static/media/refresh.c9e79158.svg";